<template>
  <div class="suspended" role="alertdialog" aria-modal="true" aria-label="Hospora is suspended">
    <div class="suspended__panel">
      <HEmptyState title="Hospora is suspended" :description="text" :icon="false">
        <template #actions>
          <HButton :href="HOSPORA_BILLING_URL" target="_blank" rel="noopener noreferrer">Pay your invoice</HButton>
          <HButton variant="secondary" @click="reload">I have paid, check again</HButton>
        </template>
      </HEmptyState>
      <p class="suspended__link">
        <a :href="HOSPORA_BILLING_URL" target="_blank" rel="noopener noreferrer">{{ HOSPORA_BILLING_URL }}</a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Full-screen, non-dismissable page shown when the API answers 402 `org_suspended` (an overdue Hospora invoice).
 * Nothing behind it is reachable: App.vue renders this INSTEAD of the router view. There is no close button; the
 * only ways on are paying (the link) or checking again once paid (reloads the app).
 */
import { computed } from 'vue'
import { HButton, HEmptyState } from '@hospora/ui'
import { HOSPORA_BILLING_URL, suspension } from '@hospora-bookings/shared-ui'

const FALLBACK = `This organisation's Hospora account is suspended because an invoice is overdue. Pay it to restore access at once.`
const text = computed(() => suspension.value?.message || FALLBACK)

function reload() {
  window.location.reload()
}
</script>

<style scoped>
.suspended {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--h-space-4, 1rem);
  background: var(--h-bg, #fff);
  color: var(--h-text, inherit);
  overflow: auto;
}
.suspended__panel {
  width: 100%;
  max-width: 32rem;
  text-align: center;
}
.suspended__link {
  margin: var(--h-space-3, 0.75rem) 0 0;
  font-size: 0.875rem;
  overflow-wrap: anywhere;
}
</style>
